
<div
  :id="content.idHTML"
  class="entete-page position-relative"
  :class="[jel_getClassObject(content), content.theme ? content.theme : 'themeClair']"
  :style="{
    '--couleurEntete': content.couleurEntete,
    '--couleurEnteteDebut': content.couleurEnteteDebut,
  }"
>
  <div :class="content.imagePleineLargeur === 'true' ? 'contenu-pleine-largeur' : 'contenu'">
    <div
      class="position-relative m-auto"
      :class="[
        { 'image-pleine-largeur': content.imagePleineLargeur === 'true' },
        gradiantType,
        { 'texte-droite': content.alignementTexte === 'droite' },
      ]"
    >
      <MediaVideo v-if="content.videoLien" :content="contentMediaVideo" />
      <MediaImageFocalPoint v-else :content="contentMediaImage" :class="alignementImage" />
      <b-row
        class="m-auto restreindre-largeur"
        :class="{
          'justify-content-sm-end': content.alignementTexte === 'droite',
        }"
      >
        <div class="texte-information px-2 px-sm-3 px-xl-4 position-absolute">
          <Titre :content="contentSurTitre" />
          <p class="titre-entete p-0 mb-1 mr-0" v-html="content.titre" />
          <div
            v-if="content.sousTitre"
            class="sous-titre pt-0 pt-xl-1"
            v-html="content.sousTitre"
          />
          <b-row>
            <b-col :cols="content.texteAdditionnel ? 8 : 12">
              <span @click.capture="gaPreventClick">
                <Hyperlien
                  :content="contentBouton"
                  class="pt-2 pb-3 pb-sm-4"
                  :class="{ themeAccent: content.boutonAccent == 'true' }"
                />
              </span>
            </b-col>
            <b-col><div v-html="content.texteAdditionnel" /></b-col>
          </b-row>
        </div>
      </b-row>
    </div>
  </div>
  <div v-if="$mq == 'xs'" class="degrade position-absolute w-100 h-100" />
</div>
